var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagSingapore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_2938)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_2938",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_2938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0628 0H-0.9375V24H35.0628V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0628 0H-0.9375V12H35.0628V0Z",
    fill: "#DF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36533 2.01165C5.70315 2.39275 4.46809 3.62351 4.1189 5.29688C3.64446 7.57028 5.12534 9.79623 7.40311 10.2714C5.10182 10.9275 2.72375 9.6046 2.07368 7.32453C1.42367 5.04453 2.74655 2.66646 5.02662 2.01639C5.82703 1.78813 6.56392 1.78669 7.36533 2.01165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90556 5.50148L5.26392 5.03376L6.05774 5.02692L6.30434 4.27161L6.55591 5.02506L7.35036 5.0263L6.71182 5.49838L6.95655 6.25432L6.30993 5.7928L5.66642 6.25866L5.90556 5.50148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78374 8.10448L6.14209 7.63675L6.93592 7.62992L7.18252 6.8746L7.43408 7.62806L8.22853 7.6293L7.58999 8.10138L7.83472 8.85731L7.18811 8.3958L6.54459 8.86166L6.78374 8.10448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70488 8.08519L9.06323 7.61747L9.85706 7.61063L10.1037 6.85532L10.3552 7.60877L11.1497 7.61001L10.5111 8.08209L10.7559 8.83803L10.1092 8.37651L9.46574 8.84237L9.70488 8.08519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.576 5.50353L9.93433 5.0358L10.7282 5.02897L10.9748 4.27365L11.2263 5.0271L12.0208 5.02835L11.3822 5.50042L11.627 6.25636L10.9803 5.79485L10.3368 6.26071L10.576 5.50353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26323 3.79055L7.62158 3.32282L8.41541 3.31599L8.66201 2.56067L8.91357 3.31412L9.70802 3.31537L9.06948 3.78744L9.31421 4.54338L8.6676 4.08187L8.02409 4.54773L8.26323 3.79055Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_2938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSingapore);
export default __webpack_public_path__ + "static/media/flag_singapore.aee7c1e6735ff6cd54cc9a994dbb9b2d.svg";
export { ForwardRef as ReactComponent };